/**
 * Pure: current origin first, then CSV legacy/alias origins, de-duplicated.
 * Kept import.meta-free so Jest can import it (the runtime accessor that reads
 * `import.meta.env` lives in owned-origins.runtime.ts).
 */
export function parseOwnedOrigins(
	currentOrigin: string,
	legacyCsv: string,
): string[] {
	const extra = legacyCsv
		.split(",")
		.map((s) => s.trim())
		.filter(Boolean)
	return Array.from(new Set([currentOrigin, ...extra]))
}
